import { Modal } from "antd";
import React from "react";
import { useSelector } from "react-redux";

const IUIModal = ({ isOpen, onClose }) => {
  const theme = localStorage.getItem("default-theme");

  const { activePatientJourneyModuleDetails } = useSelector(
    ({ dashboard }) => dashboard
  );

  return (
    <>
      <Modal
        centered
        open={isOpen}
        title="IUI Detail"
        className={`patient-registration-modal theme-${theme}`}
        maskClosable={false}
        onCancel={() => onClose()}
        width={860}
      >
        <div className="modal-details">
          <div className="modal-content-details">
            <div className="details">
              <div className="details-table">
                <div>Patient ID</div>
                <div>{activePatientJourneyModuleDetails?.patient_id}</div>
                <div>Patient</div>
                <div>
                  {activePatientJourneyModuleDetails?.patient_full_name}
                </div>
                <div>Patient Age</div>
                <div>{activePatientJourneyModuleDetails?.patient_dob}</div>
                <div>Partner</div>
                <div>
                  {activePatientJourneyModuleDetails?.partner_full_name}
                </div>
                <div>Partner Age</div>
                <div>{activePatientJourneyModuleDetails?.partner_dob}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">
                Patient Registration & Basic info from patient
              </div>
              <div className="details-table">
                <div>Male Partner</div>
                <div>{activePatientJourneyModuleDetails?.male_partner}</div>
                <div>Age (Male)</div>
                <div>{activePatientJourneyModuleDetails?.age_male}</div>
                <div>Female Partner</div>
                <div>{activePatientJourneyModuleDetails?.female_partner}</div>
                <div>Age (Female)</div>
                <div>{activePatientJourneyModuleDetails?.age_female}</div>
                <div>Pt. ID</div>
                <div>{activePatientJourneyModuleDetails?.pt_id}</div>
                <div>Collection</div>
                <div>{activePatientJourneyModuleDetails?.collections}</div>
                <div>Collections Other</div>
                <div>
                  {activePatientJourneyModuleDetails?.collections_other}
                </div>
                <div>Complete Collection</div>
                <div>
                  {activePatientJourneyModuleDetails?.complete_collection}
                </div>
                <div>Rec.No.</div>
                <div>{activePatientJourneyModuleDetails?.rec_no}</div>
                <div>Date</div>
                <div>{activePatientJourneyModuleDetails?.date}</div>
                <div>Referring clinic/clinician</div>
                <div>{activePatientJourneyModuleDetails?.refer_clinic}</div>
                <div>Abstinence Period (Days)</div>
                <div>
                  {activePatientJourneyModuleDetails?.abstinance_period}
                </div>
                <div>Method Of Collection</div>
                <div>
                  {activePatientJourneyModuleDetails?.method_collection}
                </div>
                <div>Collection time(CT)</div>
                <div>{activePatientJourneyModuleDetails?.collection_time}</div>
                <div>Assay time (AT)</div>
                <div>{activePatientJourneyModuleDetails?.assay_time}</div>
                <div>IUI with</div>
                <div>{activePatientJourneyModuleDetails?.iui_with}</div>
                <div>Blood Group of Husband / Donor</div>
                <div>
                  {activePatientJourneyModuleDetails?.blood_group_husband_donor}
                </div>
                <div>Frozen sample</div>
                <div>{activePatientJourneyModuleDetails?.frozen_sample}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Preliminary Semen Analysis</div>
              <div className="details-table">
                <div>Ejaculate volume</div>
                <div>{activePatientJourneyModuleDetails?.ejaculate_volume}</div>
                <div>Liquification Time</div>
                <div>
                  {activePatientJourneyModuleDetails?.liquification_time}
                </div>
                <div>Visual appearance</div>
                <div>
                  {activePatientJourneyModuleDetails?.visual_appearance}
                </div>
                <div>Viscosity</div>
                <div>{activePatientJourneyModuleDetails?.viscosity}</div>
                <div>Pus cells/Leucocytes</div>
                <div>
                  {activePatientJourneyModuleDetails?.pus_cells_leucocytes}/hpf
                </div>
                <div>Debries</div>
                <div>{activePatientJourneyModuleDetails?.debries}</div>
                <div>Concentration</div>
                <div>
                  {activePatientJourneyModuleDetails?.prelim_concentration}
                  Million/ml
                </div>
                <div>Normal forms</div>
                <div>{activePatientJourneyModuleDetails?.normal_forms}</div>
                <div>Total motile (a+b+c)</div>
                <div>
                  {activePatientJourneyModuleDetails?.prelim_total_motile}
                </div>
                <div>All progressive (a+b)</div>
                <div>
                  {activePatientJourneyModuleDetails?.prelim_all_progressive}
                </div>
                <div>a) Rapid progressive</div>
                <div>
                  {activePatientJourneyModuleDetails?.prelim_rapid_progressive}
                </div>
                <div>b) Slow progressive</div>
                <div>
                  {activePatientJourneyModuleDetails?.prelim_slow_progressive}
                </div>
                <div>c) Non-progressive</div>
                <div>
                  {activePatientJourneyModuleDetails?.prelim_non_progressive}
                </div>
                <div>d) Immotile</div>
                <div>{activePatientJourneyModuleDetails?.prelim_immotile}</div>
              </div>
            </div>
            <div className="details">
              <div className="table-title">Subsequent Semen Analysis</div>
              <div className="details-table">
                <div>Preparation Method & Media</div>
                <div>
                  {activePatientJourneyModuleDetails?.preparation_method_media}
                </div>
                <div>Batch No.</div>
                <div>{activePatientJourneyModuleDetails?.batch_no}</div>
                <div>Expiry Date</div>
                <div>{activePatientJourneyModuleDetails?.exp_date}</div>
                <div>Insemination volume</div>
                <div>
                  {activePatientJourneyModuleDetails?.insemination_volume}ml
                </div>
                <div>Concentration</div>
                <div>
                  {activePatientJourneyModuleDetails?.subsequent_concentration}
                  Million/ml
                </div>
                <div>Total motile (a+b+c)</div>
                <div>
                  {activePatientJourneyModuleDetails?.subsequent_total_motile}
                </div>
                <div>All progressive (a+b)</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.subsequent_all_progressive
                  }
                </div>
                <div>a) Rapid progressive</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.subsequent_rapid_progressive
                  }
                </div>
                <div>b) Slow progressive</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.subsequent_slow_progressive
                  }
                </div>
                <div>c) Non-progressive</div>
                <div>
                  {
                    activePatientJourneyModuleDetails?.subsequent_non_progressive
                  }
                </div>
                <div>d) Immotile</div>
                <div>
                  {activePatientJourneyModuleDetails?.subsequent_immotile}
                </div>
                <div>Prepared by</div>
                <div>{activePatientJourneyModuleDetails?.prepared_by}</div>
                <div>Approved by</div>
                <div>{activePatientJourneyModuleDetails?.approved_by}</div>
                <div>Notes</div>
                <div>{activePatientJourneyModuleDetails?.notes}</div>
                <div>Inseminated by</div>
                <div>{activePatientJourneyModuleDetails?.inseminated_by}</div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default IUIModal;
